import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { PATH } from '../constants/common';

dayjs.extend(customParseFormat);

/*
// Remove it temporarily as we will implement email change later
// Owen suggested we use .+@.+. instead, will look into it later
export const checkIsValidEmail = str => {
  return String(str)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};
 */

export const checkIsValidDate = str => {
  return (
    dayjs(str, 'DD/MM/YYYY', true).isValid() ||
    dayjs(str, 'D/MM/YYYY', true).isValid() ||
    dayjs(str, 'D/M/YYYY', true).isValid() ||
    dayjs(str, 'DD/M/YYYY', true).isValid()
  );
};

export const transformDateFormatFromDDMMYYYYToYYYYMMDD = str => {
  const arr = str.split('/');
  const day = arr[0];
  const month = arr[1];
  const year = arr[2];

  return `${year}-${month}-${day}`;
};

export const checkIsInteger = val => {
  return typeof val === 'number' && Math.floor(val) === val;
};

export const formatDatePickerInput = date => {
  // limit the max input length as 10
  if (date.length === 11) {
    return replaceChartInString(date, date.length - 1, '');
  }

  // limit the input to be only number and "/"
  if (!date[date.length - 1].match(/\d|\//)) {
    return replaceChartInString(date, date.length - 1, '');
  }

  // Format the single digit of day as double digits
  if (date.length === 2 && date[1] === '/') {
    return insertChartInString(date, 0, '0');
  }

  // Format the single digit of month as double digits
  if (date.length === 5 && date[4] === '/') {
    return insertChartInString(date, 3, '0');
  }

  // Inset "/" automatically
  if (date[date.length - 1] !== '/' && (date.length === 2 || date.length === 5))
    return date + '/';

  return date;
};

export const insertChartInString = (string, position, chart) => {
  let stringChartArr = string.split('');
  stringChartArr.splice(position, 0, chart);
  return stringChartArr.join('');
};

export const replaceChartInString = (string, position, chart) => {
  let stringChartArr = string.split('');
  stringChartArr.splice(position, 1, chart);
  return stringChartArr.join('');
};

// This function is to check whether the local part of email address (before @) is within 64 characters. It's a requirement according to rfc3696.
export const validateEmailAddressByLength = emailAddress => {
  if (typeof emailAddress !== 'string') return false;

  emailAddress = emailAddress.trim();

  if (emailAddress.length === 0 || emailAddress.length > 254) return false;

  const emailPartsArr = emailAddress.split('@');

  if (emailPartsArr.length < 2) return false;

  if (emailPartsArr[0].length === 0 || emailPartsArr[0].length > 64)
    return false;

  return true;
};

export const formatDateAsLocalTimestamp = date => {
  if (!date || !dayjs(date) || !dayjs(date).toString()) return '-';

  return dayjs(date).format('DD-MM-YYYY HH:mm Z');
};

export const getPageIndex = path => {
  let index = 0;

  switch (path) {
    case '/report':
      index = PATH.REPORT;
      break;
    case '/suspicious-traffic':
      index = PATH.SUSPICIOUS_TRAFFIC;
      break;
    case '/routing-status':
      index = PATH.ROUTING_STATUS;
      break;
    case '/alerts-suspicious-traffic':
      index = PATH.ALERTS_SUSPICIOUS_TRAFFIC;
      break;
    case '/alerts-routing-status':
      index = PATH.ALERTS_ROUTING_STATUS;
      break;
    default:
      index = PATH.OTHERS;
      break;
  }

  return index;
};

export const checkIsAPNICStaffByEmail = email => {
  if (!email) return false;

  const APNICStaffEmailRegExp = /@apnic.net$/;

  return APNICStaffEmailRegExp.test(email);
};
